import { useQuery } from '@tanstack/react-query';
import type {
  PackagingItemListQuery,
  PackagingItemListResponse,
} from '@produzionejb/types';
import { api } from './api-client';

const QK = {
  list: (q: Partial<PackagingItemListQuery>) => ['packaging-items', 'list', q] as const,
};

function toQueryString(q: Partial<PackagingItemListQuery>): string {
  const params = new URLSearchParams();
  if (q.page) params.set('page', String(q.page));
  if (q.pageSize) params.set('pageSize', String(q.pageSize));
  if (q.category) params.set('category', q.category);
  if (q.search) params.set('search', q.search);
  if (q.active !== undefined) params.set('active', String(q.active));
  const s = params.toString();
  return s ? `?${s}` : '';
}

export function usePackagingItems(query: Partial<PackagingItemListQuery>) {
  return useQuery({
    queryKey: QK.list(query),
    queryFn: () =>
      api<PackagingItemListResponse>(`/api/packaging-items${toQueryString(query)}`),
    staleTime: 30_000,
  });
}
